import React, { useState } from "react";
import { Pencil, Check, Mail, Save, AlertCircle, CheckCircle2 } from "lucide-react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const EmailEditor = () => {
  const [subject, setSubject] = useState("Welcome to our platform!");
  const [body, setBody] = useState("Hello,\nThank you for joining us!");
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  /** SAVE EMAIL CONTENT TO LARAVEL */
    const handleSave = async () => {
    setSaving(true);
    setMessage({ type: "", text: "" });

    try {
        const res = await fetch(`${API_BASE_URL}/email-template/save`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",  // <-- important (prevents redirect)
            "Authorization": `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify({
            key: "general_email",   // ← REQUIRED
            subject,
            body,
        }),
        });

        const data = await res.json();

        if (!res.ok) {
        throw new Error(data.message || "Failed to save template");
        }

        setMessage({
        type: "success",
        text: "Email template saved successfully!",
        });
        setEditing(false);

    } catch (err) {
        setMessage({ type: "error", text: err.message });
    } finally {
        setSaving(false);
    }
    };

  return (
    <div className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100 max-w-2xl w-full mx-auto mt-10">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <Mail className="h-6 w-6 text-blue-600" />
          Email Content Editor
        </h2>

        {!editing ? (
          <button
            onClick={() => setEditing(true)}
            className="px-4 py-2 flex items-center gap-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 shadow"
          >
            <Pencil className="h-4 w-4" /> Edit
          </button>
        ) : (
          <div className="flex gap-3">
            <button
              onClick={handleSave}
              disabled={saving}
              className={`px-4 py-2 flex items-center gap-2 rounded-xl text-white ${
                saving ? "bg-gray-400" : "bg-green-600 hover:bg-green-700"
              }`}
            >
              <Save className="h-4 w-4" />
              {saving ? "Saving..." : "Save"}
            </button>

            <button
              onClick={() => setEditing(false)}
              className="px-4 py-2 flex items-center gap-2 rounded-xl bg-gray-300 hover:bg-gray-400"
            >
              <Check className="h-4 w-4" /> Done
            </button>
          </div>
        )}
      </div>

      {editing ? (
        <div className="space-y-4">
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-blue-400"
          />

          <textarea
            value={body}
            onChange={(e) => setBody(e.target.value)}
            className="w-full p-3 border rounded-xl min-h-[200px] focus:ring-2 focus:ring-blue-400"
          ></textarea>
        </div>
      ) : (
        <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 space-y-3">
          <h3 className="text-xl font-semibold text-gray-900">{subject}</h3>
          <p className="text-gray-700 whitespace-pre-wrap">{body}</p>
        </div>
      )}

      {/* Success / Error Message */}
      {message.text && (
        <div
          className={`mt-6 p-4 rounded-xl flex items-start space-x-3 ${
            message.type === "success"
              ? "bg-green-50 border border-green-200"
              : "bg-red-50 border border-red-200"
          }`}
        >
          {message.type === "success" ? (
            <CheckCircle2 className="h-5 w-5 text-green-600" />
          ) : (
            <AlertCircle className="h-5 w-5 text-red-600" />
          )}
          <p
            className={`text-sm font-medium ${
              message.type === "success" ? "text-green-800" : "text-red-800"
            }`}
          >
            {message.text}
          </p>
        </div>
      )}
    </div>
  );
};

export default EmailEditor;
